import parse from "html-react-parser";
import React from "react";

import { PrimaryButton } from "_components/atoms/button";
import Typography        from "_components/atoms/typography";

import StepperHeader from "../stepperHeader";

import useStyles from "./styles";

const StepThree = ( { type, monetisationData, currentStep, totalSteps, stepData, toggleFeedback } ) => {

	const { isRejected, modalState, nextApprovalDate } = monetisationData;
	const { title, subtitle, earnings, description }   = stepData;
	const isRejectedF                                  = isRejected;
	const showHeader                                   = ( type === "reels" ) || earnings === 0;
	const showApprovalDate                             = modalState === 1;
	const { classes }                                  = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.stepThreeWrapper }>

			{showHeader && (
				<StepperHeader
					currentStep       = { currentStep }
					isCompleted       = { type === "live" }
					isRejected        = { isRejectedF && modalState === 0 }
					nextApprovalDate  = { nextApprovalDate }
					showApprovalDate  = { showApprovalDate }
					subTitle          = { subtitle }
					title             = { title }
					totalSteps        = { totalSteps }
				/>
			)}

			{description && (
				<Typography
					className = { type === "live" ? classes.earningDescription : "" }
					title     = { parse ( description ) }
				/>
			)}

			{( isRejectedF && modalState === 0 ) && (
				<PrimaryButton
					className = { classes.rejectedButton }
					onClick   = { toggleFeedback }
					size      = "small"
					title     = { "View Feedback" }
				/>
			)}

			{( earnings !== undefined ) && (
				<Typography
					className = { classes.earningCount }
					title     = { parse ( "&#x20B9;" ) + ` ${ earnings }` }
				/>
			)}

		</div>
	);
};

export default StepThree;